// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"c56a8a84","29":"42c69fc7","101":"a2f2bac1","744":"97a0e45d","907":"ee1947ff"}[chunkId] + ".chunk.css";
};